import moment from 'moment';

/**
 * Retrieves and flattens data from a specified key within paginated GraphQL data.
 *
 * This function accepts a GraphQL response object that contains multiple pages of data
 * and extracts data based on the provided key, flattening the results into a single array.
 * If the key or data is not found, it returns an empty array.
 *
 * @param {any} graphQLData - The GraphQL data object containing a paginated structure,
 * usually with a `pages` array where each page includes data for a specific key.
 * @param {string} key - The key is the GraphQL query key coming from backend.
 */
function getDataByKey(graphQLData: any, key: string) {
  return (
    graphQLData?.pages?.flatMap((page: any) => page[key]?.data ?? []) ?? []
  );
}

export { getDataByKey };

export const getStartDateEndDate = (input: string) => {
  const startDate = moment(input, 'YYYY-MM')
    .startOf('month')
    .format('YYYY-MM-DD');
  const endDate = moment(input, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');

  return { startDate, endDate };
};

export const formatLOC = (value: number) => {
  if (isNaN(value)) return value;
  if (value >= 1000000) {
    return (value / 1000000).toFixed(1) + 'M';
  }
  if (value >= 1000) {
    return (value / 1000).toFixed(1) + 'K';
  }

  return value;
};

export function hasGoals(pathname: string): boolean {
  return /^\/goals(\/|$)/.test(pathname);
}

export const warpY = (y: any) => {
  if (y <= 10) {
    // Stretch 0–10 to 0–30%
    return (y / 10) * 30;
  } else if (y <= 90) {
    // Compress 10–90 to 30–70%
    return 30 + ((y - 10) / 80) * 40;
  } else {
    // Stretch 90–100 to 70–100%
    return 70 + ((y - 90) / 10) * 30;
  }
};

export const unwarpY = (v: any) => {
  if (v <= 30) {
    return (v / 30) * 10;
  } else if (v <= 70) {
    return 10 + ((v - 30) / 40) * 80;
  } else {
    return 90 + ((v - 70) / 30) * 10;
  }
};

export const applyWarpToPercentiles = (data: any) => {
  return data?.map((item: any) => {
    const newItem = { ...item };

    Object.keys(newItem)?.forEach((key) => {
      if (
        key.toLowerCase().includes('percentile') &&
        typeof newItem[key] === 'number'
      ) {
        newItem[key] = warpY(newItem[key]);
      }
    });

    return newItem;
  });
};
